module.exports = __webpack_public_path__ + "img/nintendo_switch.dc9ed6b.png";